<template>
	<div class="cl_switchPage_container">
		<div class="cl_switchPage_wrapper">
			<span class="left_action" :class="{disabled: currentSwitchPage <= 1}" v-waves @click="handlePre">
				<cl-svg-icon icon-class="left-arrow"></cl-svg-icon>
			</span>

			<p class="page_info Tip_Color">
				<span class="AkrobatM Main_Color">{{currentSwitchPage}}</span>
				<em class="ml8 mr8">/</em>
				<span class="AkrobatM">{{totalPageText}}</span>
			</p>

			<span class="right_action" :class="{disabled: currentSwitchPage >= totalPage}" v-waves @click="handleNext">
				<cl-svg-icon icon-class="right-arrow"></cl-svg-icon>
			</span>
		</div>
	</div>
</template>

<script>
	/**
	 * ComponentName: cl-switch-page
	 * Created Date: 2022/11/17
	 * Author: zhangjun
	 * 组件说明：简单的分页组件，传入当前页数和总页数，
	 * 		当前页数不会小于1，总页数后端可能会返回0，这里也处理成不小于1。
	 * eg: <cl-switch-page></cl-switch-page>
	 */
	export default {
		name: 'cl-switch-page',
		props: {
			// 当前页数
			currentPage: {
				type: [Number, String],
				default: 1,
			},
			// 总页数
			totalPage: {
				type: [Number, String],
				default: 1,
			}
		},
		model: {
			prop: 'currentPage',
			event: 'change'
		},
		data() {
			return {
				description: '简单的分页组件，看起来像《 1 / 12 》',
				currentSwitchPage: this.currentPage,
			}
		},

		watch: {
			currentPage(newV) {
				this.currentSwitchPage = newV
			}
		},

		computed: {
			totalPageText() {
				return this.totalPage <= 0 ? 1 : this.totalPage
			}
		},

		methods: {
			handlePre() {
				if (this.currentSwitchPage > 1) {
					this.currentSwitchPage--;
					this.$emit('change', this.currentSwitchPage);
				}
			},

			handleNext() {
				if (this.currentSwitchPage < this.totalPage) {
					this.currentSwitchPage++;
					this.$emit('change', this.currentSwitchPage);
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
.cl_switchPage_container {
	display: inline-block;
	.cl_switchPage_wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		.left_action, .right_action {
			display: inline-block;
			width: 32px;
			height: 32px;
			text-align: center;
			line-height: 32px;
			border-radius: 6px;
			color: #fff;
			background: #3663E1;
			cursor: pointer;
			&.disabled {
				color: #B7B7BF;
				background: #F3F3F3;
			}
		}

		.page_info {
			width: 50px;
			margin: 0 10px;
			text-align: center;
			font-size: 16px;
		}
	}
}
</style>